import React, {
  FunctionComponent,
  useEffect,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { FormTemplateSection } from 'data/template/template.types';
import { DistributorConfigurationTableData } from 'data/distributorConfiguration/distributorConfiguration.types';
import { FieldUpdateHandlerParam } from 'shared/form';
import DistributorConfigurationTable from '../DistributorConfigurationTable';
import { filterDistributorConfigurations } from './FormSectionDistributorConfigs.utils';

type Props = {
  isEditing: boolean,
  data: DistributorConfigurationTableData[],
  formSectionName: string,
  templateSection: FormTemplateSection | undefined,
  nodeName?: string
  is5gcVcpEnabled?: boolean
  instructionalText?: string
  onDistributorUpdate?: (distributorConfiguration: DistributorConfigurationTableData) => void
  onFieldUpdate?: (param: FieldUpdateHandlerParam) => void
}

export const FormSectionDistributorConfigs: FunctionComponent<Props> = ({
  isEditing,
  data,
  formSectionName,
  templateSection,
  nodeName,
  is5gcVcpEnabled,
  instructionalText,
  onDistributorUpdate,
}: Props) => {
  const { t } = useTranslation();

  const [distributorConfigsTableData, setDistributorConfigsTableData] =
    useState<DistributorConfigurationTableData[]>([]);

  useEffect(() => {
    const filteredData = filterDistributorConfigurations(
      data,
      templateSection,
      nodeName,
      is5gcVcpEnabled,
    );

    setDistributorConfigsTableData(filteredData);
  }, [is5gcVcpEnabled, data, templateSection, nodeName]);

  const renderInstructionalText = ():JSX.Element => {
    if (instructionalText && instructionalText !== '') {
      return <p dangerouslySetInnerHTML={{ __html: instructionalText }} />;
    }

    return (
      <p>
        {t('accessFunction.form.distributor.allOfSameType')}
        <br />
        <span dangerouslySetInnerHTML={{ __html: t('accessFunction.form.distributor.listeners') }} />
      </p>
    );
  };

  if (!templateSection) {
    return null;
  }

  return (
    <div data-testid={`FormSectionDistributorConfigs-${formSectionName}`}>
      {renderInstructionalText()}
      <DistributorConfigurationTable
        isEditing={isEditing}
        rowData={distributorConfigsTableData}
        templateSection={templateSection}
        onDistributorUpdate={onDistributorUpdate}
      />
    </div>
  );
};

export default FormSectionDistributorConfigs;
